import { certificateUrl, s3Url } from '@/utils/common/env.constants';

/**
 * Get the PDF URL for a certificate
 */
export const getCertificatePdfUrl = (certificateId: string, isCareerPath: boolean): string => {
  if (isCareerPath) {
    return `${s3Url}/learn/certificates/${certificateId}.pdf`;
  }
  return `${certificateUrl}/${certificateId}.pdf`;
};

/**
 * Extract certificate IDs from router query params
 * Supports format: /learn/certificate/${id}?id1={id1}&id2={id2}&id3={id3}...
 */
export const extractCertificateIds = (
  query: Record<string, string | string[] | undefined>
): string[] => {
  const ids: string[] = [];

  // Add primary id from route
  if (query.id) {
    ids.push(query.id as string);
  }

  // Add additional ids from query params (id1, id2, id3, ...)
  Object.keys(query).forEach((key) => {
    if (key.match(/^id\d+$/) && query[key]) {
      ids.push(query[key] as string);
    }
  });

  return ids;
};

/**
 * Hide PDF annotation and text layers from the DOM
 */
export const hidePdfLayers = (): void => {
  // Hide all annotation layers
  const annotationElements = document.getElementsByClassName(
    'react-pdf__Page__annotations annotationLayer'
  );
  for (let i = 0; i < annotationElements.length; i += 1) {
    (annotationElements[i] as HTMLElement).style.display = 'none';
  }

  // Hide all text layers
  const textLayerElements = document.getElementsByClassName(
    'react-pdf__Page__textContent textLayer'
  );
  for (let i = 0; i < textLayerElements.length; i += 1) {
    (textLayerElements[i] as HTMLElement).style.display = 'none';
  }
};
